import {keyMirror} from 'utils/DBUtils';

export const Types = keyMirror({
  REQUEST_PRIZE: null,
  GET_PRIZE_IMAGES_PAGE: null,
  RECEIVED_PRIZE: null,
  UNMOUNT_PRIZE: null,

  PUBLISH_PRIZE_SUBMIT: null,
  PUBLISH_PRIZE_SUCCESS: null,
  PUBLISH_PRIZE_ERROR: null,

  CLOSE_PUBLISH_PRIZE_MODAL: null
});

export const requestPrizeAction = (prizeId, isRelatedPrize = false) => ({
  type: Types.REQUEST_PRIZE,
  prizeId,
  isRelatedPrize
});

export const getPrizeImagesPageAction = (count, page, prizeId) => ({
  type: Types.GET_PRIZE_IMAGES_PAGE,
  count,
  page,
  prizeId
});

export const receivedPrizeAction = prize => ({
  type: Types.RECEIVED_PRIZE,
  prize
});

export const unmountPrizeAction = () => ({
  type: Types.UNMOUNT_PRIZE
});

export const publishPrizeSubmitAction = prizeId => ({
  type: Types.PUBLISH_PRIZE_SUBMIT,
  prizeId
});

export const publishPrizeSuccessAction = () => ({
  type: Types.PUBLISH_PRIZE_SUCCESS
});

export const publishPrizeErrorAction = error => ({
  type: Types.PUBLISH_PRIZE_ERROR,
  error
});

export const closePublishPrizeModalAction = () => ({
  type: Types.CLOSE_PUBLISH_PRIZE_MODAL
});



// WEBPACK FOOTER //
// ./public/pages/EditPrize/actions.js